import * as yup from "yup";

const ObjectRoleSchema = yup.object().shape({
  id: yup.string(),
  roleId: yup.object().required().nullable(),
  objectId: yup.object().required().nullable(),
});

export { ObjectRoleSchema };
